export const OwaRolloutOverridesButtonID: string = 'owaRolloutOverridesButton';
export const OwaPremiumButtonID: string = 'owaPremiumButton';
export const OwaTimePanelButtonID: string = 'Time';
export const OwaSettingsButtonID: string = 'owaSettingsButton';
export const OwaFeedbackButtonID: string = 'owaFeedbackButton';
export const OwaWhatsNewButtonID: string = 'whatsnew';
export const OwaHelpButtonID: string = 'owahelp';
export const OwaSupportButtonID: string = 'owasupport';
export const OwaActivityFeedButtonID: string = 'owaActivityFeedButton';
export const OwaDiagnosticsButtonId: string = 'owaDiagnostics';
export const OwaNoteFeedButtonID: string = 'owaNoteFeedButton';
export const OwaMeetNowButtonID: string = 'owaMeetNowButton';
export const OwaInboxForMeButtonID: string = 'owaInboxForMeButton';

export const OwaRolloutOverridesFlexPaneID: string = 'OwaRolloutOverrides';
export const OwaPremiumFlexPaneID: string = 'owaPremiumButton';
export const OwaTimePanelFlexPaneID: string = 'OwaTimePanel';
export const OwaSettingsFlexPaneID: string = 'OwaSettings';
export const OwaFeedbackFlexPaneID: string = 'OwaFeedback';
export const OwaWhatsNewFlexPaneID: string = 'whatsNewPane';
export const OwaHelpFlexPaneID: string = 'OwaHelp';
export const OwaSupportFlexPaneID: string = 'OwaSupport';
export const OwaActivityFeedFlexPaneID: string = 'OwaActivityFeed';
export const OwaExpressionFlexPaneID: string = 'Expressions';
export const OwaSkypeFlexPaneID: string = 'Skype';
export const OwaIdeasFlexPaneID: string = 'Ideas';
export const OwaNoteFeedFlexPaneID: string = 'NoteFeed';
export const OwaInboxForMeFlexPaneID: string = 'InboxForMe';
